import QuotationsResultsLcl from "./quotation-results-lcl.component";

export default QuotationsResultsLcl;
